module.exports = __webpack_public_path__ + "static/media/landing-kitty08.0aa6701c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/home-page/landing-kitty08.svg
// module id = 123
// module chunks = 0